const leaguesReducer = (state, action) => {

    switch (action.type) {
        case "ADD_LEAGUE":
            return {
                leagues: [...state.leagues, action.payload]
            };
        case "INIT_LEAGUES":
            return {
                leagues: action.payload
            }
        case "UPDATE_LEAGUE":
            let newVal = action.payload;
            let newLeagues = state.leagues;
            let idx = state.leagues.findIndex((l) => l._id === newVal._id);
            if(idx > -1){
                newLeagues[idx] = newVal;
            }
            return { leagues: newLeagues };
    
        default:
            //return state
            return { 
                leagues: state.leagues
                //league: state.league
                //leagues: state.leagues
            }
    }
};
  
export default leaguesReducer